export const limits = {
  min: 200,
  max: 5000,
  secs: 1,
};

export enum Product {
  SaaS = 'SaaS',
  Software = 'Software',
}

export const DisplayName = {
  SaaS: 'SaaS',
  Software: 'On-Premises',
};

export const unattendedRobots = {
  min: 1,
  max: 1000,
};

export const attendedRobots = {
  min: 1,
  max: 1000,
};
export const environments = {
  min: 1,
  max: 10,
};

export const defaultConfiguration = 3; // Custom Size

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30RPAPE = '30AKY';
